import { TThunkAction } from '../../types/redux';
import {
  COMPLAIN_REQUEST,
  COMPLAIN_FAIL_REQUEST,
  IComplainRequest,
  COMPLAIN_COMPLAINT_SENDED,
  IComplainFailRequest,
} from '../../constants/actionTypes/complain';
import { Action } from 'redux';
import { createSendComplaint } from '../../api';
import { proccessSendComplaintsError } from '../../utils/complain';

export type TComplainComplaintSended = 'complain/complaintSended';

export interface IComplainComplaintSended extends Action<TComplainComplaintSended> {
  offerId: number;
  complaintId: number;
  getUserFeedback: boolean;
  type: TComplainComplaintSended;
}

export interface ISendComplaintsParameters {
  offerId: number;
  complaintId: string;
  message?: string;
}

export function sendComplaint({ offerId, complaintId, message }: ISendComplaintsParameters): TThunkAction {
  return (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch<IComplainRequest>({ type: COMPLAIN_REQUEST, offerId });

    const sendComplaintFn = createSendComplaint(httpApi);

    return sendComplaintFn(offerId, complaintId, message)
      .then(({ complaintId, getUserFeedback }) => {
        dispatch<IComplainComplaintSended>({
          offerId,
          complaintId: Number(complaintId),
          getUserFeedback,
          type: COMPLAIN_COMPLAINT_SENDED,
        });
      })
      .catch(reason => {
        const error = proccessSendComplaintsError(reason, logger);
        dispatch<IComplainFailRequest>({
          offerId,
          error,
          type: COMPLAIN_FAIL_REQUEST,
        });
      });
  };
}
